import React, { useEffect, useState } from 'react';
import { useWallofLoveContext } from '../contexts/WallofLoveContext';
import ReviewModal from '../components/ReviewModal';
import './style/WallofLove.css';
import LoadingLogo from '../components/LoadingLogo';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

function WallOfLove() {
  const { reviews, fetchReviews, loadingReviews, errorReviews } = useWallofLoveContext();
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    fetchReviews();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const [day, month, year] = dateString.split('-');
    const dateObj = new Date(`${year}-${month}-${day}`);
    return dateObj.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };

  // Affiche le loader sur TOUTE la page
  if (loadingReviews) {
    return (
      <div className="walloflove-page">
        <LoadingLogo />
      </div>
    );
  }

  return (
  <>
    <Helmet>
      <title>BeOnWall – Wall of Love</title>
      <meta name="description" content="Découvrez les témoignages de nos utilisateurs et comment BeOnWall a transformé leurs événements." />
      <meta name="keywords" content="BeOnWall, QR code, photo en direct, live photo, album numérique, photowall, livre d'or numérique, photo booth app, photo stream, wedding captions, guestbook, candid photo, qr scan, create qr code, link to qr, scan qr code from image, soirée, mariage, anniversaire, événement interactif" />
      <meta property="og:title" content="BeOnWall – Wall of Love" />
      <meta property="og:description" content="Des avis sincères de clients ayant utilisé BeOnWall pour leurs événements. Découvrez leur expérience !" />
      <meta property="og:url" content="https://beonwall.com/WallofLove" />
      <meta property="og:image" content="https://beonwall.com/assets/logobeonwall.png" />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
    <div className="walloflove-page">
      <h1 className="wall-title">{t('WallOfLovePage.title')}</h1>
      <p className="wall-subtitle">
        {t('WallOfLovePage.subtitle')}
      </p>
      <div className="review-button-container">
        <button className="review-submit-btn-gold" onClick={() => setShowModal(true)}>
          {t('WallOfLovePage.SendReview')}
        </button>
      </div>
      {showModal && <ReviewModal onClose={() => setShowModal(false)} />}
      {errorReviews ? (
        <p className="error">Error: {errorReviews}</p>
      ) : (
        <div className="review-box-container">
          {[...reviews]
            .sort((a, b) => {
              const [da, ma, ya] = a.Date.split('-');
              const [db, mb, yb] = b.Date.split('-');
              const dateA = new Date(`${ya}-${ma}-${da}`);
              const dateB = new Date(`${yb}-${mb}-${db}`);
              return dateB - dateA;
            })
           .map((review, index) => (
            <div key={index} className="review-box">
              {review.Type && (
                <div className="testimonial-tag">{review.Type}</div>
              )}
              <div className="review-box-header">
                <h3 className="review-name">{review.Name || 'Anonymous'}</h3>
                <span className="review-date">{formatDate(review.Date)}</span>
              </div>
              <div className="review-rating">⭐ {review.Rate}.0</div>
              <p className="review-description">{review.Description}</p>
            </div>
          ))
}
        </div>
      )}
    </div>
  </>
  );
}

export default WallOfLove;
